/**
 * List Schema of CargaResponsavel
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {CargaResponsavel} from '@/model/resource/CargaResponsavel'

/* TODO: review generated schema */
export class ListCargaResponsavelSchema extends Schema {
  readonly name = 'ListCargaResponsavel'

  readonly fieldSet: FieldSet<CargaResponsavel> = {
    ehEmbarcador: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.ehEmbarcador),
      },
    }),
    carga: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.carga?.$id,
      },
    }),
    endereco: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.endereco?.$id,
      },
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavel?.$id,
      },
    }),
    responsavelFilial: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavelFilial?.$id,
      },
    }),
    inscricaoEstadual: (): FieldComponent => ({
      is: Component.Render,
    }),
    substitutoTributario: (): FieldComponent => ({
      is: Component.Render,
    }),
    inscricaoMunicipal: (): FieldComponent => ({
      is: Component.Render,
    }),
    municipioIcms: (): FieldComponent => ({
      is: Component.Render,
    }),
    cnaeFiscal: (): FieldComponent => ({
      is: Component.Render,
    }),
    codigoRegimeTributario: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
